export const brand = {
  name: 'aliv',
  tagline: 'Identity verification your candidates trust',
  description:
    'Biometric liveness detection powered by AWS Rekognition. Fast, secure, and frictionless.',
  domain: 'aliv.me',
} as const;
